import { IReduxAction } from '../../../services/interfaces/common-interface';
import { changePasswordLoading } from './auth-actions';
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  CLEAR_STATE,
  SET_LOADING,
  SET_USER_SELECTED_FOR_CONTEXT,
  OPEN_CHANGE_PASSWORD_MODAL,
  CHANGE_PASSWORD_CANCEL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_LOADING
} from './auth-constants';

const INITIAL_STATE = {
  loading: false,
  openPasswordModal: false,
  token: '',
  oldPassword: '',
  changePasswordLoading: false,
  successfullyEmailed: false,
  authenticated: false,
  user: null,
  tenantID: null
};

const authReduder = (state = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING: {
      return {
        ...state,
        loading: action.loading
      };
    }
    case LOGIN_SUCCESS: {
      const { user, tenantID } = action.payload;
      return {
        ...state,
        authenticated: true,
        user,
        tenantID
      };
    }

    case LOGOUT_SUCCESS: {
      return {
        ...INITIAL_STATE
      };
    }

    case RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        successfullyEmailed: true
      };
    }

    case CLEAR_STATE: {
      return {
        ...INITIAL_STATE
      };
    }

    case SET_USER_SELECTED_FOR_CONTEXT: {
      return {
        ...state,
        user: {
          authenticated: true,
          ...action.payload
        }
      };
    }

    case OPEN_CHANGE_PASSWORD_MODAL: {
      return {
        ...state,
        openPasswordModal: true,
        token: action.payload.token,
        oldPassword: action.payload.oldPassword
      };
    }

    case CHANGE_PASSWORD_SUCCESS:
    case CHANGE_PASSWORD_CANCEL: {
      return {
        ...state,
        openPasswordModal: false,
        token: '',
        oldPassword: ''
      };
    }

    case CHANGE_PASSWORD_LOADING: {
      return {
        ...state,
        changePasswordLoading: action.payload
      };
    }

    default:
      return state;
  }
};

export default authReduder;
